<script>
  import { ignore } from "../../../Common/tools";
  import {M} from "../../../external";

  export let data;
  export let onChange = ignore;

  let selectedValue;
  if (data && data.settings) {
    selectedValue = data.settings[0].value;
  }

  const onFieldChange = () => {
    if (selectedValue) {
      data.settings = [{ key: "hours", value: selectedValue }];
      data.name = data.settings[0].value + " " + data.settings[0].key;
      if (data.settings[0].value == 1) {
        data.name = data.name.substr(0, data.name.length - 1);
      }
    } else {
      data.name = null;
      data.settings = [];
    }
    onChange();
  };
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.TRIGGER_ABANDON}</h4>
  <div class="popup-input-wrapper f-left mt-25 mb-5" id="selectContactProperty">
    <div class="info">
      <h5>{M.ABANDON_AFTER}</h5>
    </div>
    <div class="input-wrapper">
      <input
        bind:value={selectedValue}
        on:keyup={onFieldChange}
        type="text"
        name="propertyValue"
        class="focus transition-border"
        placeholder="{M.ABANDON_HOURS}" />
    </div>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
